import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable, of } from "rxjs";
import { environment } from "src/environments/environment";
import { CustomerInvoice, CustomerInvoiceResponse, jsonToCustomerInvoice, jsonToCustomerInvoiceResponse } from "../models/customer-invoice.model";
import _ from "lodash";

@Injectable()
export class InvoiceService {
    constructor(private http: HttpClient) { }

    getInvoices(start: number, take: number) : Observable<CustomerInvoiceResponse> {
        return this.http.get<CustomerInvoiceResponse>(`${environment.baseUrl}/api/invoice?start=${start}&take=${take}`).pipe(map(res => jsonToCustomerInvoiceResponse(res)));
    }
}